import { useQuery } from "react-query";
import axios from "axios";
import { useState } from "react";
import { gns_endpoint, rootUrl } from "../../../utils/useAxios";
import {decryptPayload} from "../../../utils/useAxios";
// import CryptoJS from "crypto-js";

//   export const decryptPayload = (Base64CBC) => {
// 		const parsedKey = CryptoJS.enc.Utf8.parse("ZzYzPHAzLnBiS0E=");
// 		const iv = CryptoJS.enc.Utf8.parse("BBBBBBBBBBBBBBBB");
// 		const decrypted = CryptoJS.AES.decrypt(Base64CBC, parsedKey, {
// 			iv: iv,
// 			mode: CryptoJS.mode.CBC,
// 		});
// 		return decrypted.toString(CryptoJS.enc.Utf8);
//   };

export const useStateLgaData = () => {
    const [stateFormat, setStateFormat] = useState([]);
    // Get all States and there LGA
    const fetchStateLgaList = async () => {
        const { data } = await axios.get(`${rootUrl}${gns_endpoint}/states/?size=100`);

        var respdata = JSON.parse(decryptPayload(data.data));

        if (respdata) {
            const modifiedResponse = respdata?.results?.map((state) => {
                return {
                    value: state.name,
                    label: state.name,
                };
            });

            setStateFormat(modifiedResponse);
        }

        return respdata?.results;
    };
    return [stateFormat, useQuery("statesLga", fetchStateLgaList)];
};
